export default __webpack_public_path__ + "static/media/segre16.8db4e7b5.jpg";